import React from "react";
import PropTypes from "prop-types";
import { TextField, InputAdornment } from "@mui/material";

const TextInput = ({
  placeholder,
  name,
  value,
  onChange,
  InputStartIcon,
  type,
  InputEndIcon,
  id,
  fullWidth,
  multiline,
  rows,
  disabled,
  readonly,
  maxLength,
  inputError,
  helperText,
  variant,
  size,
  required,
  onkeydown,
  styleProps,
}) => {
  return (
    <TextField
      sx={styleProps}
      required={required}
      error={inputError}
      helperText={helperText}
      id={id}
      // inputProps={{ maxLength }}
      type={type}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      onKeyDown={onkeydown}
      InputProps={{
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment position="end">{InputEndIcon}</InputAdornment>
        ),
      }}
    />
  );
};

TextInput.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  InputStartIcon: PropTypes.element,
  type: PropTypes.string,
  InputEndIcon: PropTypes.element,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  maxLength: PropTypes.number,
  inputError: PropTypes.bool,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  required: PropTypes.bool,
  styleProps: PropTypes.object,
};

TextInput.defaultProps = {
  type: "text",
  fullWidth: true,
  multiline: false,
  disabled: false,
  readonly: false,
  maxLength: 255,
  inputError: false,
  helperText: "",
  variant: "outlined",
  size: "small",
  required: false,
  styleProps: {},
};

export default TextInput;
